import gql from 'graphql-tag'
export default gql`mutation loginMutation($scope: String, $password: String!, $username: String!) {
  login(scope: $scope, password: $password, username: $username) {
    access_token
    scope
    expires_in
    token_type
  }
}`